// import main from './main.js';
// import subscribe from './subscribe.js';
// import embedVideo from './embed-video.js';
// import subject from './subject.js'; // 专题详情
import { setPage as setPageUtil } from '@/app-shared/utils/pageConfigUtil';
// export default {
//   main,
//   subscribe,
//   subject,
//   'embed-video': embedVideo
// };
export const setPage = async (page = 'main') => {
  let module = '';
  switch (page) {
    case 'subscribe':
      module = await import(/* webpackChunkName: "subscribe" */ './subscribe.js').then(
        module => module.default
      );
      break;

    case 'embedVideo':
      module = await import(/* webpackChunkName: "embedVideo" */ './embed-video.js').then(
        module => module.default
      );
      break;
    case 'subject':
      module = await import(/* webpackChunkName: "embedVideo" */ './subject.js').then(
        module => module.default
      );
      break;
    default:
      module = await import(/* webpackChunkName: "liveMain" */ './main.js').then(
        module => module.default
      );
      break;
  }

  setPageUtil(module, page == 'concise' || page == 'fullscreen' ? 'main' : page);
};
